module.exports = __webpack_public_path__ + "static/media/ploni-medium-aaa.0537c0a0.woff";